import { Component, OnInit, Inject } from '@angular/core';
import { CompleterService, CompleterData } from 'ng2-completer';
import '../../public/css/styles.css';
import {TranslateService} from 'ng2-translate';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import { DOCUMENT } from '@angular/platform-browser';

var json = require("json!./../../public/resources/properties.json");

@Component({
  selector: 'my-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.css')]
})
export class AppComponent implements OnInit { 

  name: string = "David";
  activeMenu: boolean = false;
  private searchStr: string;
  private dataService: CompleterData;
  private searchData = [
    { color: 'red', value: '#f00' },
    { color: 'green', value: '#0f0' },
    { color: 'blue', value: '#00f' },
    { color: 'cyan', value: '#0ff' },
    { color: 'magenta', value: '#f0f' },
    { color: 'yellow', value: '#ff0' },
    { color: 'black', value: '#000' }
  ];
  private category: string;

  constructor(private completerService: CompleterService, 
  private translateService: TranslateService, 
  private route: Router, 
  private actualRoute: ActivatedRoute, 
  private location: Location,
  @Inject(DOCUMENT) private document: Document) {
    this.dataService = completerService.local(this.searchData, 'color', 'color');
        // this language will be used as a fallback when a translation isn't found in the current language
        translateService.setDefaultLang('cat');

         // the lang to use, if the lang isn't available, it will use the current loader to get them
        translateService.use('cat');
        
        this.category="home";
  }

  ngOnInit() {
    if(typeof this.location.path().split("/")[1] !== 'undefined')
      this.category=this.location.path().split("/")[1];
    else
      this.category="home";

  }

  isLang(language: string) {
      return language == this.translateService.currentLang;
  }

  setLang(language: string) {
      this.translateService.use(language);
  }
  
  isCategory(cat: string) {
    return this.category==cat;
  }

  setCategory(cat: string) {
    this.category = cat;
    this.document.body.scrollTop = 0;
  }

  activateMenu() {
    this.activeMenu = !this.activeMenu;    
    if(this.activeMenu) this.document.body.scrollTop = 0;
  }

  disableMenu() {
    this.activeMenu = false;
  }

  isActiveMenu() {
    return this.activeMenu;
  }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.component.ts
 **/